<template>
  <v-card rounded="lg" flat>
    <v-card-title class="subtitle-1 font-weight-bold">Entrega</v-card-title>
    <v-card-text>
      <v-text-field
        type="date"
        label="Data de entrega"
        disabled
        v-model="novopedido.dtentrega"
      ></v-text-field>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: mapState("pedidos", ["novopedido"]),
  methods: {
    ...mapGetters("pedidos", ["getDataEntrega"]),
  },
  mounted() {
    this.novopedido.dtentrega = this.getDataEntrega();
  },
};
</script>

<style>
</style>